export var COLOR_WHITE = '#fff';
export var COLOR_BRAND = '#01b6f5';
export var COLOR_BRAND_ACTIVE = '#009acf';
export var COLOR_BRAND_LIGHT = 'rgba(0, 184, 245, 0.2)';
export var COLOR_BRAND_2 = '#07b0ea';
export var COLOR_SUCCESS = '#1de9b6';
export var COLOR_SUCCESS_ACTIVE = '#1ad1a3';
export var COLOR_SUCCESS_LIGHT = 'rgba(29, 233, 182, 0.2)';
export var COLOR_ERROR = '#fe4849';
export var COLOR_ERROR_ACTIVE = '#ea4243';
export var COLOR_GRAY_1 = '#F6F7F9';
export var COLOR_GRAY_2 = '#D7D9E2';
export var COLOR_GRAY_3 = '#a4a7b5';
export var COLOR_GRAY_4 = '#3F4954';
export var COLOR_GRAY_TRANSPARENT_1 = 'rgba(244, 246, 249, 0.4)';
export var COLOR_GRAY_TRANSPARENT_2 = 'rgba(82, 95, 127, 0.3)';
export var COLOR_GRAY_TRANSPARENT_3 = 'rgba(82, 95, 127, 0.15)';
export var COLOR_GRAY_DARK_TRANSPARENT = 'rgba(42, 48, 57, 0.2)';
export var COLOR_DARK_1 = '#2A3039';
export var COLOR_YELLOW_1 = '#fc0';
export var COLOR_WARNING = COLOR_YELLOW_1;
export var COLOR_WARNING_DARK = '#FFB900';
export var COLOR_WARNING_LIGHT = '#FFDC7F';
export var COLOR_PURPLE = '#663398';